// Servicio packing - Sprint 36.
import apiClient from '../../../api/apiClient';

const B = '/packing';

export async function listPackings({ page = 1, per_page = 25, estado = '' } = {}) {
  const p = new URLSearchParams();
  p.set('page', page); p.set('per_page', per_page);
  if (estado) p.set('estado', estado);
  const r = await apiClient.get(B + '/?' + p.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function getPacking(id) {
  const r = await apiClient.get(B + '/' + id);
  return (r && r.data) || null;
}

export async function updatePacking(id, payload) {
  const r = await apiClient.put(B + '/' + id, payload);
  return (r && r.data) || null;
}

export async function scanPacking(id, code) {
  const r = await apiClient.post(B + '/' + id + '/scan', { code });
  return (r && r.data) || null;
}

export async function completarPacking(id) {
  const r = await apiClient.post(B + '/' + id + '/completar', {});
  return (r && r.data) || null;
}

export async function prepararEnvio(id) {
  const r = await apiClient.get(B + '/' + id + '/preparar-envio');
  return (r && r.data) || null;
}
